import React from "react";

export const TileWrapper = ({ children, className = "" }) => (
  <div className={`container-fluid pt-3 pb-2 ${className}`}>{children}</div>
);
